export const HOME = "/home";
export const LOGIN = "/login";
export const REGISTER = "/cadastros";
export const FORGOT_PASSWORD = "/forgot-password";
export const RESET_PASSWORD = "/reset-password";
export const DASHBOARD = "/dashboard";
export const PROFILE = "/perfil";
export const ADMIN = "/admin";
export const USERS = "/usuarios";
export const USER_DETAILS = "/users/:id";
export const DEFAULT = "/";
//paths do cliente
export const CLIENTES = "/clientes";
export const CADASTROCLIENTES = "/clientes/cadastro";
export const EDITARCLIENTES = "/clientes/editar";
//paths dos gestores
export const GESTORES = "/gestores";
export const CADASTROGESTORES = "/gestores/cadastro";
export const EDITARGESTORES = "/gestores/editar";
//paths dos projetos
export const PROJETOS = "/projetos";
export const ADDPROJECT = "/projetos/adicionar";
//paths das empresas
export const EMPRESAS = "/empresas";
export const CADASTROEMPRESAS = "/empresas/cadastro";
export const EDITAREMPRESAS = "/empresas/editar/";
export const USUARIOSEMPRESA = "/empresas/users";
export const CADASTRAUSUSARIOEMPRESA = "/empresas/users/cadastro";
//paths dos providers
export const PROVIDERS = "/providers";
//paths das tarifas
export const TARIFAS = "/tarifas";
//paths dos planos
export const PLANOS = "/planos";
//paths das promoções
export const PROMOÇÃO = "/promocao";
//paths dos vendedores
export const VENDEDORES = "/vendedores";
//paths dos produtos
export const PRODUTOS = "/produtos";
//paths dos niveis de acesso
export const NIVEISACESSO = "/niveisacesso";
//lista de card dos cadastros
export const CADASTROS = "/cadastros";
//lançamentos futuros
export const LANCAMENTOSFUTUROS = "/financeiro/lancamentos";
export const VENDAS = "/vendas";
export const CONTASFIXAS = "/financeiro/contafixa";
export const CADASTROCONTASFIXAS = "/financeiro/contafixa/cadastro";
export const LISTADEVENDAS = "/vendas/listadevendas";
export const LISTADEVENDASTEMPOREAL = "/vendas/listadevendastemporeal";
export const EDITBOLEPIX = "/bolepix/editar/:id";
export const VENDASBOLETO = "/vendas/boletos";
export const CALENDER = "/vendas/bolepix/calender";
export const VENDASBOLEPIX = "/vendas/bolepix";
// Gestao de boletos: a vencer / vencidos / recebidos, com exportacao
export const GESTAOBOLEPIX = "/vendas/bolepix/gestao";
export const NOVAVENDASBOLETOS = "/vendas/boletos/nova";
export const NOVAVENDASBOLEPIX = "/vendas/bolepix/nova";
export const DETAILSBOLEPIX = "/vendas/bolepix/lote/detalhes/:idLote";
export const NOVAVENDABOLEPIXLOTE = "/vendas/bolepix/nova/lote";
export const VENDADIGITADA = "/vendas/digitadas";
export const ADDVENDADIGITADA = "/vendas/digitadas/cadastrar";
export const ADDVENDADIGITADACARTAO = "/vendas/digitadas/cartao/cadastrar";
export const VENDASBOLETOS = "/financeiro/boletos";
export const PAGAMENTOSNOVO = "/financeiro/pagamentos-novo";
export const TRANSFERENCIAS = "/financeiro/transferencias";
export const TRANSFERENCIASNOVO = "/financeiro/transferencias-novo";
export const FINANCEIRO = "/financeiro";
export const EXTRACTDETAIL = "/financeiro/extrato/detalhe";
export const REGISTERFAVORITES = "/financeiro/favoritos";
export const LISTADEASSINATURASVINCULADAS =
  "/vendasrecorrentes/planos/vinculados";
export const ADDFAVORITES = "/financeiro/cadastro/favoritos";
export const EDITFAVORITES = "/financeiro/editar/favorito/:idFavorecido";
export const CREDITO = "/credito";
export const SOLICITACAOPAGAMENTO = "/solicitacoes/pagamento";
export const ADDSOLICITACAOPAGAMENTO = "/solicitacoes/pagamento/novo";
export const ADDSOLICITACAOPAGAMENTONEW = "/solicitacoes/pagamentonovo/novo";
export const SOLICITACAOTRANSFERENCIA = "/solicitacoes/transferencia";
export const ADDSOLICITACAOTRANSFERENCIA = "/solicitacoes/transferencia/novo";
export const ADDSOLICITACAOTRANSFERENCIANEW =
  "/solicitacoes/transferencia-novo/novo";
// Rotas de Venda
export const SUPORT = "/servico";
export const ADDSUPORT = "/cadastroservico";
export const WPPSUPORT = "https://wa.me/5562998088567";

// Rotas de Pagamento
export const PAYMENT = "/payment";
export const PIX = "/pix";
//rotas para os dados pessoais
export const DADOSPESSOAIS = "/personaldata";
export const TAXASPESSOAIS = "/taxas";
//rotas para extrato detalhado
export const CONSULTATRANSACAO = "/financeiro/consultatransacao";
//rotas para venda pix direto
export const PIXDIRECT = "/direto";
export const ADDPIXDIRECT = "/direto/cadastro";
//vendas recorrentes
export const VENDASRECORRENTES = "/vendasrecorrentes";
export const LISTAGEMCOMPRADORES = "/vendasrecorrentes/compradores";
export const LISTAGEMPLANOS = "/vendasrecorrentes/planos";
export const LISTAGEMVENDASRECORRENTES = "/vendasrecorrentes/listagem";
export const CADASTROCOMPRADORES = "/vendasrecorrentes/compradores/cadastro";
export const CADASTROPLANOSRECORRENCIA = "/vendasrecorrentes/planos/cadastro";
export const ADDVENDASRECORRENTES = "/vendasrecorrentes/cadastro";
export const LISTAGEMVENDASRECORRENTESTRANSACOES =
  "/vendasrecorrentes/listagem/transacoes/:id";
//aceite de termos
export const MEUSTERMOS = "/termos";
